<template>
  <div class="page page--account" v-if="isLoggedIn">
    <Sharing />
    <MakeOffers />
    <ShareQuery />
    <Sales />
  </div>
  <div class="page page--account" v-else>
    <Login />
  </div>
</template>

<script>
import Login from '@/components/Login.vue';
import Sharing from '@/components/Sharing.vue';
import MakeOffers from '@/components/MakeOffers.vue';
import Sales from '@/components/Sales.vue';
import ShareQuery from '@/components/ShareQuery.vue';

export default {
  components: {
    Sharing,
    Login,
    MakeOffers,
    Sales,
    ShareQuery,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
};
</script>
